import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scroll } from 'shared/utils/scroll/scroll';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scroll({ timeout: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};
